export const fmt = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmt0 = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const maskMobile = (m) => (m ? m.slice(0, 2) + "****" + m.slice(-2) : "");

// "17:00" -> "5PM", "12:30" -> "12:30PM"
export const to12h = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const hh = h % 12 || 12;
  return `${hh}${m ? ":" + String(m).padStart(2, "0") : ""}${h < 12 ? "AM" : "PM"}`;
};

/* First round of an interval show = booking open time + one interval ("9:15AM–10:15PM" means draws, not booking) */
export const firstDrawTime = (g) => {
  if (!g) return "";
  if (g.runtime?.first_draw_time) return g.runtime.first_draw_time;
  const [h, m] = (g.open_time || "09:00").split(":").map(Number);
  const t = h * 60 + m + (g.interval_minutes || g.runtime?.interval_minutes || 30);
  return `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
};

/* "today" | "yesterday" | null for a YYYY-MM-DD draw date (IST) */
export const dayBucket = (ymd) => {
  if (!ymd) return null;
  const ist = new Date(Date.now() + 330 * 60000);
  const today = ist.toISOString().slice(0, 10);
  const yday = new Date(ist.getTime() - 86400000).toISOString().slice(0, 10);
  const day2 = new Date(ist.getTime() - 2 * 86400000).toISOString().slice(0, 10);
  return ymd === today ? "today" : ymd === yday ? "yesterday" : ymd === day2 ? "daybefore" : null;
};
export const dayBucketLabel = (bucket, lang) => (bucket === "today" ? (lang === "ta" ? "இன்று" : "Today") : bucket === "yesterday" ? (lang === "ta" ? "நேற்று" : "Yesterday") : bucket === "daybefore" ? (lang === "ta" ? "முந்தாநாள்" : "Day before") : lang === "ta" ? "முந்தையது" : "Earlier");
/* Ticket rate label: "₹10 × 2 = ₹20" — every ticket must show the rate it was booked at */
export const rateOf = (b) => Number(b?.rate || (b?.quantity ? (b.amount || 0) / b.quantity / (b.box_size || 1) : 0));
export const fmtRate = (r) => "₹" + (Number(r) % 1 ? Number(r).toFixed(2) : Number(r).toLocaleString("en-IN"));
export const rateLine = (b) => { const r = rateOf(b); if (b?.set_qty) return `${fmtRate(r)} × ${b.set_qty} set × ${b.set_count || (b.set_boards || []).length || 3} boards = ${b.quantity} qty · ${fmtRate(b.amount)}`; return r ? `${fmtRate(r)} × ${b.quantity || 1}${b.box_size > 1 ? ` × ${b.box_size}` : ""} = ${fmtRate(b.amount)}` : fmtRate(b?.amount); };

export const dateLabel = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const dateTimeLabel = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const statusColor = (s) => {
  const map = {
    pending: "text-amber-400 bg-amber-500/10",
    processing: "text-sky-400 bg-sky-500/10",
    success: "text-emerald-400 bg-emerald-500/10",
    won: "text-emerald-400 bg-emerald-500/10",
    approved: "text-emerald-400 bg-emerald-500/10",
    rejected: "text-red-400 bg-red-500/10",
    failed: "text-red-400 bg-red-500/10",
    lost: "text-red-400 bg-red-500/10",
    cancelled: "text-slate-400 bg-slate-500/10",
  };
  return map[s] || "text-slate-300 bg-slate-500/10";
};
